import { render, staticRenderFns } from "./SelectManufacturer.vue?vue&type=template&id=6963af60"
import script from "./SelectManufacturer.vue?vue&type=script&lang=js"
export * from "./SelectManufacturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports